import { render, staticRenderFns } from "./ZhuanjiaList.vue?vue&type=template&id=3676b784&scoped=true&"
import script from "./ZhuanjiaList.vue?vue&type=script&lang=js&"
export * from "./ZhuanjiaList.vue?vue&type=script&lang=js&"
import style0 from "./ZhuanjiaList.vue?vue&type=style&index=0&id=3676b784&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3676b784",
  null
  
)

export default component.exports